import React from 'react';

const Sound = () => (
  <svg
    width="9"
    height="8"
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.752.618a.271.271 0 0 0-.39 0 .287.287 0 0 0 0 .398 3.823 3.823 0 0 1 1.087 2.69 3.823 3.823 0 0 1-1.087 2.69.287.287 0 0 0 0 .398.271.271 0 0 0 .39 0A4.39 4.39 0 0 0 9 3.706 4.39 4.39 0 0 0 7.752.618z"
      fill="#8C8C8C"
    />
    <path
      d="M6.869 1.521a.271.271 0 0 0-.39 0 .287.287 0 0 0 0 .4 2.57 2.57 0 0 1 0 3.57.287.287 0 0 0 0 .4.272.272 0 0 0 .39 0 3.144 3.144 0 0 0 0-4.37z"
      fill="#8C8C8C"
    />
    <path
      d="M5.986 2.425a.271.271 0 0 0-.39 0 .287.287 0 0 0 0 .399 1.27 1.27 0 0 1 0 1.764.287.287 0 0 0 0 .399.272.272 0 0 0 .39 0c.69-.707.69-1.856 0-2.562zM0 2.605v2.201c0 .156.123.282.276.282h1.403V2.323H.276A.279.279 0 0 0 0 2.605zM4.852.027a.27.27 0 0 0-.292.037L2.23 2.01v3.39l2.33 1.947a.272.272 0 0 0 .292.037.282.282 0 0 0 .158-.255V.282a.283.283 0 0 0-.158-.255z"
      fill="#8C8C8C"
    />
  </svg>
);

export default Sound;
